import React from "react";
import cn from "classnames";

import { Link } from "react-router";
import { RouterLinkProps } from "./RouterLink.props";
import styles from "../Link.module.scss";

/**
 * @deprecated Use `import { Link } from capitalrx-components-2.0/lib/general` instead.
 */
const RouterLink: React.FC<RouterLinkProps> = ({
  children,
  id,
  testId,
  size = "reg",
  className,
  to,
  replace,
}: RouterLinkProps): JSX.Element => {
  const LinkClasses = cn(
    [styles.a],
    { [styles.xsmall]: size === "xsmall" },
    { [styles.small]: size === "small" },
    { [styles.large]: size === "large" },
    { [styles["small-display"]]: size === "small-display" },
    className,
  );

  return (
    <Link
      className={LinkClasses}
      data-testid={testId ? `test__${testId}` : undefined}
      id={id}
      to={to}
      replace={replace}
    >
      {children}
    </Link>
  );
};

export default RouterLink;
